import { 
  ADD_NEW_PRICING,
  ADD_NEW_PRICING_ERROR,
  ADD_NEW_PRICING_SUCCESS,
  EDIT_PRICING,
  EDIT_PRICING_ERROR,
  EDIT_PRICING_SUCCESS,
  GET_BRANCHS_PRICING,
  GET_BRANCHS_PRICING_ERROR,
  GET_BRANCHS_PRICING_SUCCESS,
  GET_COMPLETION_TIMES_PRICING,
  GET_COMPLETION_TIMES_PRICING_ERROR,
  GET_COMPLETION_TIMES_PRICING_SUCCESS,
  GET_LANGUAGES_PRICING,
  GET_LANGUAGES_PRICING_ERROR,
  GET_LANGUAGES_PRICING_SUCCESS,
  GET_PRICING,
  GET_PRICING_ERROR,
  GET_PRICING_SUCCESS,
  GET_WORDS_PRICING,
  GET_WORDS_PRICING_ERROR,
  GET_WORDS_PRICING_SUCCESS,
} from 'redux/constants/Pricing';

/**
 * GET PRICING
 * @returns 
 */
export const getPricing = (query) => {
  return {
    type: GET_PRICING,
    payload: {
      query
    }
  }
};

/**
 * GET PRICING SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getPricingSuccess = (data) => {
  return {
    type: GET_PRICING_SUCCESS,
    data
  }
};

/**
 * GET PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const getPricingError = (message) => {
  return {
    type: GET_PRICING_ERROR,
    message
  }
};

/**
 * GET BRANCHS PRICING
 * @returns 
 */
 export const getBranchsPricing = (query) => {
  return {
    type: GET_BRANCHS_PRICING,
    payload: {
      query
    }
  }
};

/**
 * GET BRANCHS PRICING SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getBranchsPricingSuccess = (data) => {
  return {
    type: GET_BRANCHS_PRICING_SUCCESS,
    data
  }
};

/**
 * GET BRANCHS PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const getBranchsPricingError = (message) => {
  return {
    type: GET_BRANCHS_PRICING_ERROR,
    message
  }
};

/**
 * GET LANGUAGES PRICING
 * @returns 
 */
 export const getLanguagesPricing = (query) => {
  return {
    type: GET_LANGUAGES_PRICING,
    payload: {
      query
    }
  }
};

/**
 * GET LANGUAGES PRICING SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getLanguagesPricingSuccess = (data) => {
  return {
    type: GET_LANGUAGES_PRICING_SUCCESS,
    data
  }
};

/**
 * GET LANGUAGES PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const getLanguagesPricingError = (message) => {
  return {
    type: GET_LANGUAGES_PRICING_ERROR,
    message
  }
};

/**
 * GET COMPLETION TIMES
 * @returns 
 */
 export const getCompletionTimesPricing = (query) => {
  return {
    type: GET_COMPLETION_TIMES_PRICING,
    payload: {
      query
    }
  }
};

/**
 * GET COMPLETION TIMES SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getCompletionTimesPricingSuccess = (data) => {
  return {
    type: GET_COMPLETION_TIMES_PRICING_SUCCESS,
    data
  }
};

/**
 * GET COMPLETION TIMES ERROR
 * @param {*} message 
 * @returns 
 */
export const getCompletionTimesPricingError = (message) => {
  return {
    type: GET_COMPLETION_TIMES_PRICING_ERROR,
    message
  }
};

/**
 * GET WORDS PRICING
 * @returns 
 */
 export const getWordsPricing = (query) => {
  return {
    type: GET_WORDS_PRICING,
    payload: {
      query
    }
  }
};

/**
 * GET WORDS PRICING SUCCESS
 * @param {*} data 
 * @returns 
 */
export const getWordsPricingSuccess = (data) => {
  return {
    type: GET_WORDS_PRICING_SUCCESS,
    data
  }
};

/**
 * GET WORDS PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const getWordsPricingError = (message) => {
  return {
    type: GET_WORDS_PRICING_ERROR,
    message
  }
};

/**
 * EDIT PRICING
 * @returns 
 */
 export const editPricing = (data, cb = () => {}) => {
  return {
    type: EDIT_PRICING,
    payload: {
      data,
      cb
    }
  }
};

/**
 * EDIT PRICING SUCCESS
 * @returns 
 */
export const editPricingSuccess = () => {
  return {
    type: EDIT_PRICING_SUCCESS,
  }
};

/**
 * EDIT PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const editPricingError = (message) => {
  return {
    type: EDIT_PRICING_ERROR,
    message
  }
};

/**
 * ADD NEW PRICING
 * @returns 
 */
 export const addNewPricing = (data, cb = () => {}) => {
  return {
    type: ADD_NEW_PRICING,
    payload: {
      data,
      cb
    }
  }
};

/**
 * ADD NEW PRICING SUCCESS
 * @returns 
 */
export const addNewPricingSuccess = () => {
  return {
    type: ADD_NEW_PRICING_SUCCESS,
  }
};

/**
 * ADD NEW PRICING ERROR
 * @param {*} message 
 * @returns 
 */
export const addNewPricingError = (message) => {
  return {
    type: ADD_NEW_PRICING_ERROR,
    message
  }
};